import * as React from 'react';
import cx from 'classnames'

import './subtitle.styles.scss';

export type SubtitleProps = {
  className?: string;
  text: string;
  type?: 'heading' | 'chip';
};

export const Subtitle: React.FC<SubtitleProps> = (props) => {
  const { text, type, className } = props;

  return (
    <h6 className={cx("FhqDesignToolSubtitle", `FhqDesignToolSubtitle--${type}`, className)}>
      {text}
    </h6>
  );
};
